import { Add } from "@mui/icons-material";
import { Button, IconButton, Typography } from "@mui/material";
import { usePermissions } from "src/grading/hooks/usePermissions";
import { permissions } from "src/grading/utils/permissionsHelpers";
import useStyles from "./InviteMemberButton.styles";

const InviteMemberButton = (props: React.ComponentProps<typeof Button>) => {
  const classes = useStyles();

  const { hasPermissions } = usePermissions();

  const canInviteMember = hasPermissions(
    permissions.INVITE_ORGANIZATION_MEMBER.action,
    permissions.INVITE_ORGANIZATION_MEMBER.subject,
  );

  return (
    canInviteMember && (
      <IconButton className={classes.inviteButton} onClick={props.onClick}>
        <Typography variant="button">Invite Member</Typography>
        <Add />
      </IconButton>
    )
  );
};

export default InviteMemberButton;
